import { useAppSelector } from '../../hooks';
import { addCurrencySymbol } from '../../shared/useUtils';
import { OrderProcessBottomNavBarStyle } from '../../styles/components/order-process';
import { Button } from '../common/ui';

export interface IOrderProcessBottomNavBarProps {
  totalAmount: number;
  prevLabel: string;
  nextLabel: string;
  onPrev: () => void | Promise<void>;
  onNext: () => void | Promise<void>;
  canGoPrev?: boolean;
  canGoNext?: boolean;
  indeterminate?: boolean;
}
const OrderProcessBottomNavBar = (props: IOrderProcessBottomNavBarProps) => {
  const appState = useAppSelector((state) => state.app);
  const totalAmountLabel = () => {
    return addCurrencySymbol(
      props.totalAmount,
      appState.currentCurrency?.isoCode || 'USD',
      appState.currentLocale || 'en'
    );
  };

  return (
    <div
      className={OrderProcessBottomNavBarStyle['order-process-bottom-navbar']}>
      <div
        className={
          OrderProcessBottomNavBarStyle['order-process-bottom-navbar-total']
        }>
        <span
          className={
            OrderProcessBottomNavBarStyle[
              'order-process-bottom-navbar-total-label'
            ]
          }>
          Total
        </span>
        <span
          className={
            OrderProcessBottomNavBarStyle[
              'order-process-bottom-navbar-total-amount'
            ]
          }>
          {props.indeterminate ? (
            <>
              <div className="loader-ellipsis-inline"></div>
            </>
          ) : (
            totalAmountLabel()
          )}
        </span>
      </div>
      <div
        className={
          OrderProcessBottomNavBarStyle['order-process-bottom-navbar-buttons']
        }>
        {props.canGoPrev && (
          <Button color="secondary" onClick={props.onPrev}>
            {props.prevLabel}
          </Button>
        )}
        <Button
          color={'tertiary'}
          disabled={!props.canGoNext || props.indeterminate}
          onClick={props.onNext}>
          {props.nextLabel}
        </Button>
      </div>
    </div>
  );
};

export default OrderProcessBottomNavBar;
